module.exports = __webpack_public_path__ + "img/deliverySuccess.190ef106.png";